import React from "react";

/**
 * SwoopyLogo Component
 * 
 * Displays ONLY the "Swoopy" lettering as an SVG wordmark
 * No cup icon, no extra decoration - just the word
 * Styled to match the original logo lettering
 */
export default function SwoopyLogo({
  size = 40,
  className = "",
  style = {}
}) {
  // Scale based on size prop (base height 40px)
  const scale = size / 40;
  const width = 120 * scale;
  const height = 40 * scale;
  
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 120 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        display: 'inline-block',
        filter: 'drop-shadow(0 2px 6px rgba(233, 116, 143, 0.15))',
        ...style
      }}
    >
      <defs>
        <linearGradient id="swoopy-text-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F5A3B5" />
          <stop offset="50%" stopColor="#E9748F" />
          <stop offset="100%" stopColor="#D85A78" />
        </linearGradient>
      </defs>
      <text 
        x="60" 
        y="30" 
        textAnchor="middle"
        fontFamily="'Fredoka', system-ui, sans-serif"
        fontSize="28"
        fontWeight="600"
        fill="url(#swoopy-text-gradient)"
        style={{ letterSpacing: '0.02em' }}
      >
        Swoopy
      </text>
    </svg>
  );
}

/**
 * SwoopyWordmark - Simplified text-only wordmark
 * For use in headers and various contexts
 */
export function SwoopyWordmark({ 
  size = "md", 
  className = "",
  style = {} 
}) {
  const sizes = {
    sm: { height: 24, fontSize: 18 },
    md: { height: 32, fontSize: 24 },
    lg: { height: 44, fontSize: 32 },
    xl: { height: 56, fontSize: 42 },
  };
  
  const config = sizes[size] || sizes.md;
  
  return (
    <div
      className={`swoopy-wordmark ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: `${config.height}px`,
        ...style
      }}
    >
      <span
        style={{
          fontFamily: "'Fredoka', system-ui, sans-serif",
          fontWeight: 600,
          fontSize: `${config.fontSize}px`,
          background: 'linear-gradient(145deg, #F5A3B5 0%, #E9748F 50%, #D85A78 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          letterSpacing: '0.02em',
          filter: 'drop-shadow(0 1px 3px rgba(233, 116, 143, 0.12))',
        }}
      >
        Swoopy
      </span>
    </div>
  );
}
